import React from "react";
import './about.scss';
import getConfig from "../app/config";

const About = () => {

    const { beta: isBeta } = getConfig() as any;

    return (
        <div className="marketing-about">
            <div className="marketing-about-box">
                <div className="marketing-about-content">
                    {isBeta && <span>As the site is currently in beta, there may be a few bugs. If you find any, please report them to us and we'll get them fixed for you ASAP. </span>}
                    <span> These initial features are just the start for Filmanize - we're committed to shaping it into the most valuable film production software out there. Your ideas and feedback are important to us. Our roadmap is flexible, so we're open to new suggestions and revising our plans based on your needs. Filmanize is a tool for first ADs, created by first ADs, and we'd love for you to help guide its direction. Join the conversation on our </span><a href="https://discord.gg/4G4E87Y5E4" target="_blank">Discord server</a>.
                </div>
            </div>
        </div>
    )
}

export default About;